var _rect, _set, _set2, _animateTransform, _animateTransform2, _animateTransform3, _animateTransform4, _animateTransform5, _animateTransform6, _set3, _animateTransform7, _animateTransform8, _set4, _animateTransform9, _animateTransform10, _set5, _animateTransform11, _animateTransform12, _set6, _animateTransform13, _animateTransform14, _set7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    onload: "initialize(evt)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "none",
    x: 0,
    y: 0,
    width: "50px",
    height: "50px"
  })), /*#__PURE__*/React.createElement("g", {
    id: "id0b75ecfb442452a2445ff202",
    mask: "url(#canvasMask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "id5f135c521668d4ffba978b8c",
    visibility: "hidden"
  }, _set || (_set = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "id56f5fe2d27e45eda778197a8",
    visibility: "hidden"
  }, _set2 || (_set2 = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0s; loop.end",
    dur: "0.5s",
    repeatCount: 1,
    fill: "none",
    from: "-17.605 18.100",
    to: "17.429 18.100",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.0 0.55 0.45 1.0"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0.5s; loop.end + 0.5s",
    dur: "2s",
    repeatCount: 1,
    fill: "none",
    from: "17.428 18.100",
    to: "17.428 18.100",
    calcMode: "discrete"
  })), _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "2.5s; loop.end + 2.5s",
    dur: "0.5s",
    repeatCount: 1,
    fill: "none",
    from: "17.429 18.100",
    to: "69.605 18.100",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.55 0.0 1.0 0.45"
  })), _animateTransform4 || (_animateTransform4 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0s; loop.end",
    dur: "0.5s",
    repeatCount: 1,
    fill: "none",
    from: "-0.0 -0.0",
    to: "-0.0 -0.0",
    calcMode: "discrete"
  })), _animateTransform5 || (_animateTransform5 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0.5s; loop.end + 0.5s",
    dur: "2s",
    repeatCount: 1,
    fill: "none",
    from: "-0.0 -0.0",
    to: "-0.0 -0.0",
    calcMode: "discrete"
  })), _animateTransform6 || (_animateTransform6 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "2.5s; loop.end + 2.5s",
    dur: "0.5s",
    repeatCount: 1,
    fill: "none",
    from: "-0.0 -0.0",
    to: "-0.0 -0.0",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("g", {
    id: "idd20af3dc101615caf647f3c5",
    visibility: "hidden"
  }, _set3 || (_set3 = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), _animateTransform7 || (_animateTransform7 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "-4.001 0.0",
    to: "-4.001 0.0",
    calcMode: "discrete"
  })), _animateTransform8 || (_animateTransform8 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "-0.0 -0.0",
    to: "-0.0 -0.0",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ide1ec5c594eeb13117c87cf64",
    d: "M 12,0 L 0,0 C 0,0 11.199,12.1 12.798,13.898 C 14.298,15.398 14.298,16.597 12.9,17.996 C 11.5,19.395 0,31.895 0,31.895 L 11,31.895 C 11.599,31.895 12.297,31.795 12.797,31.498 C 13.396,31.299 13.896,30.9 14.294,30.4 C 15.094,29.602 16.493,28.002 16.493,28.002 L 25.993,18.002 C 27.593,16.402 27.593,15.503 26.093,14.003 L 16.593,3.803 C 16.593,3.803 14.394,1.303 13.894,0.803 C 13.696,0.503 13.396,0.304 12.998,0.204 C 12.698,0.105 12.299,0.005 11.999,0.005 L 11.999,0.005 M 11.999,0.005 ",
    style: {
      fill: "#64c6bb",
      fillOpacity: 1,
      stroke: "none"
    },
    visibility: "hidden"
  }, _set4 || (_set4 = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), _animateTransform9 || (_animateTransform9 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "0.0 0.0",
    to: "0.0 0.0",
    calcMode: "discrete"
  })), _animateTransform10 || (_animateTransform10 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "-13.6049 -15.9485",
    to: "-13.6049 -15.9485",
    calcMode: "discrete"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "id3cead953bc11bd8818809105",
    visibility: "hidden"
  }, _set5 || (_set5 = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), _animateTransform11 || (_animateTransform11 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "8.3 0.002",
    to: "8.3 0.002",
    calcMode: "discrete"
  })), _animateTransform12 || (_animateTransform12 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "-0.0 -0.0",
    to: "-0.0 -0.0",
    calcMode: "discrete"
  })), /*#__PURE__*/React.createElement("path", {
    id: "id802ba3851309ce3b33792ae8",
    d: "M 34.099,14 C 34.099,14 26.301,5.601 25.801,5.101 C 25.301,4.601 24.503,3.803 22.305,3.803 L 16.607,3.803 L 26.107,14.002 C 27.607,15.502 27.607,16.4 26.007,18 L 16.608,28.099 L 22.908,28.099 C 24.008,27.999 25.108,27.499 25.905,26.701 C 26.504,26.002 34.004,18.002 34.004,18.002 C 35.601,16.402 35.601,15.503 34.101,14.003 L 34.101,14.003 M 34.101,14.003 ",
    style: {
      fill: "#3b66b0",
      fillOpacity: 1,
      stroke: "none"
    },
    visibility: "hidden"
  }, _set6 || (_set6 = /*#__PURE__*/React.createElement("set", {
    attributeName: "visibility",
    attributeType: "CSS",
    to: "visible",
    begin: "0s; loop.end",
    fill: "none"
  })), _animateTransform13 || (_animateTransform13 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "replace",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "0.0 0.0",
    to: "0.0 0.0",
    calcMode: "discrete"
  })), _animateTransform14 || (_animateTransform14 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    begin: "0s; loop.end",
    dur: "3s",
    repeatCount: 1,
    fill: "none",
    from: "-25.9065 -15.951",
    to: "-25.9065 -15.951",
    calcMode: "discrete"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "looper",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    style: {
      fill: "none",
      stroke: "none"
    }
  }, _set7 || (_set7 = /*#__PURE__*/React.createElement("set", {
    id: "loop",
    attributeName: "x",
    to: 0,
    begin: "0s; loop.end",
    dur: "3s",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.10c89eefe9fe7cbdf99bcfe1879564f3.svg";
export { ForwardRef as ReactComponent };